import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import './ShoppingCart.scss';

const ShoppingCart = () => {
  const { cartItems, removeFromCart } = useCart();
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();

  const toggleCart = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckout = () => {
    setIsOpen(false);
    navigate('/cart');
  };

  return (
    <div className="shopping-cart">
      <button className="cart-toggle" onClick={toggleCart}>
        <FontAwesomeIcon icon={faShoppingCart} />
        {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
      </button>

      {isOpen && (
        <div className="cart-dropdown">
          <h3>Selected Solutions & Services</h3>
          {cartItems.length === 0 ? (
            <p className="empty-cart">Your cart is empty</p>
          ) : (
            <>
              <ul className="cart-items">
                {cartItems.map(item => (
                  <li key={item.id} className="cart-item">
                    <div className="item-info">
                      <h4>{item.title}</h4>
                      <p>{item.type}</p>
                    </div>
                    <button
                      className="remove-item"
                      onClick={() => removeFromCart(item.id)}
                      aria-label="Remove item"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </li>
                ))}
              </ul>
              <button className="btn btn--primary" onClick={handleCheckout}>
                Check out
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ShoppingCart;
